import { inject } from '@vercel/analytics';
import '../sass/main.scss';
import './styles.css';
import canvasDotsBg from '../bgCanvas.js';
import setupMobileNav from '../nav.js';

// Initialize Vercel Analytics
inject();

const SOURCE_URL =
  'https://raw.githubusercontent.com/jackthoene/sky130-frogger/main/src/project.v';

window.onload = function () {
  canvasDotsBg();
  setupMobileNav();

  const btn = document.getElementById('copy-btn');
  const status = document.getElementById('copy-status');

  btn.addEventListener('click', async () => {
    btn.disabled = true;
    setStatus(status, 'Fetching project.v…', '');

    try {
      const res = await fetch(SOURCE_URL, { cache: 'no-store' });
      if (!res.ok) throw new Error(`GitHub returned ${res.status}`);
      const text = await res.text();

      await navigator.clipboard.writeText(text);
      setStatus(
        status,
        `Copied ${text.length.toLocaleString()} chars — paste into the project.v tab on VGA Playground.`,
        'ok',
      );
    } catch (err) {
      setStatus(
        status,
        `Couldn't auto-copy (${err.message}). Open ${SOURCE_URL} in a new tab and copy manually.`,
        'err',
      );
    } finally {
      btn.disabled = false;
    }
  });
};

function setStatus(el, msg, kind) {
  el.textContent = msg;
  el.className = 'frogger-play__status' + (kind ? ` frogger-play__status--${kind}` : '');
}
